import type { IMeetingSharedNotificationData } from "@frontend-shared/types";
import { Share2 } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IMeetingSharedCardProps {
  uuid: string;
  data: IMeetingSharedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewMeeting: (meetingUuid: string) => void;
}

const MeetingSharedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewMeeting,
}: IMeetingSharedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewMeeting = useCallback(
    () => onViewMeeting(data.meetingUuid),
    [onViewMeeting, data.meetingUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="meeting_shared"
      createdAt={createdAt}
      isRead={isRead}
      icon={<Share2 className="h-5 w-5 text-blue-500" />}
      iconBgClassName="bg-blue-500/10"
      ctaLabel={t("view_meeting")}
      onCtaClick={handleViewMeeting}
      body={t("type.meeting_shared.body", {
        sharerName: data.sharerName,
        meetingTitle: data.meetingTitle,
      })}
    />
  );
};

export const MeetingSharedCard = memo(MeetingSharedCardComponent);
